module.exports = __webpack_public_path__ + "img/add-product.01a0f183.png";